import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function apiError(e) {
  const status = e?.response?.status;
  const method = String(e?.config?.method || "get").toLowerCase();
  // Rede de segurança em duas camadas para 403:
  // - GET (leitura em background): silencia (a tela já esconde/redireciona).
  // - Ação (POST/PUT/PATCH/DELETE): SEMPRE mostra o aviso, para que nenhum
  //   botão que escapar do hasPerm fique "mudo" ao ser clicado.
  if (status === 403) {
    if (method === "get") return "";
    return "Você não tem permissão para esta ação";
  }
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * toast.error helper que ignora strings vazias (usado para silenciar 403).
 * Uso: toastError(err) em vez de {const _m=apiError(err); if(_m) toast.error(_m);}.
 */
export function shouldToast(msg) {
  return typeof msg === "string" && msg.length > 0;
}
